const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  email: state => state.user.user.email,
  name: state => state.user.user.name,
  id: state => state.user.user.id,
  user: state => state.user.user,
  areas: state => state.settings.settings.areas,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  permission: state => state.permission,
  sessions: state => state.settings.settings.sessions,
}
export default getters
